/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Compax Authorization Service
 * API by Compax
 * OpenAPI spec version: 161.0.0-SNAPSHOT
 */

export type ChangeTwoFactorAuthenticationMethod =
  (typeof ChangeTwoFactorAuthenticationMethod)[keyof typeof ChangeTwoFactorAuthenticationMethod];

export const ChangeTwoFactorAuthenticationMethod = {
  SMS: "SMS",
  APP: "APP",
  STANDARD: "STANDARD",
} as const;
